import { Logo } from 'assets'
import React from 'react'
import { Container } from 'react-bootstrap'
import './terms.css'

export default function PrivacyPolicy() {
   return (
      <div className="auth-section p-3 position-relative ">
         <div>
            <div className="logo-section">
               <img src={Logo} alt="logo" />
            </div>
            <Container>
               <div className="terms-page">
                  <h3 className="text-center text-decoration-underline">Privacy Policy</h3>
                  <div>
                     <p className="mb-2">Last updated : 12/22/2024 </p>
                     <p className="mb-2">
                        This privacy notice for Atenya Intelligence Inc. ("we," "us," or "our"),
                        describes how and why we might collect, store, use, and/or share ("process")
                        your information when you visit our website at https://atenya.ai/, or any
                        website of ours that links to this privacy policy, download or use our
                        mobile application or engage with us in any other related ways including
                        sales, marketing, events, products or services (collectively "Services").{' '}
                     </p>
                     <div className="mb-2">
                        <strong>Questions or concerns?</strong> 
                        <span className="at-text-light">
                           {' '}
                           Reading this privacy notice will help you understand your privacy rights
                           and choices. By using our Services, you confirm that you have read and
                           understand the terms of this Privacy Policy. If you do not agree with our
                           policies and practices, please do not use our Services. If you still have
                           any questions or concerns, please contact us at support@atenya.ai.{' '}
                        </span>
                     </div>
                     <div className="mb-2">
                        <strong>SUMMARY OF KEY POINTS </strong>
                     </div>
                     <div className="mb-2">
                        <strong className="mb-2">
                           This summary provides key points from our privacy notice, but you can
                           find out more details about any of these topics by clicking the link
                           following each key point or by using our table of contents below to find
                           the section you are looking for.{' '}
                        </strong>
                     </div>

                     <div className="mb-2">
                        <strong>What personal information do we process? </strong> 
                        <span className="at-text-light">
                           {' '}
                           When you visit, use, or navigate our Services, we may process personal
                           information depending on how you interact with us and the Services, the
                           choices you make, and the products and features you use. Learn more
                           about personal information you disclose to us.
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>Do we process any sensitive personal information? </strong>
                        <span className="at-text-light">
                           We may process sensitive personal information when necessary, with your
                           consent or as otherwise permitted by applicable law. Learn more
                           about sensitive information we process.
                           <strong>[We do not process sensitive personal information]</strong>
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>Do we receive any information from third parties? </strong>
                        <span className="at-text-light">
                           We may receive information from public databases, marketing partners,
                           social media platforms, and other outside sources. We are not responsible
                           for the accuracy of information provided by third parties. Learn more
                           about information collected from other sources.
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>How do we process your information? </strong>
                        <span className="at-text-light">
                           We process your information to provide, improve, and administer our
                           Services, communicate with you, for security and fraud prevention, and to
                           comply with law. We may also process your information for other purposes
                           with your consent. We process your information only when we have a valid
                           legal reason to do so. Learn more about how we process your information.
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>
                           In what situations and with which types of parties do we share personal
                           information?{' '}
                        </strong>
                        <span className="at-text-light">
                           We may share information in specific situations and with
                           specific categories of third parties. Learn more about when and with whom
                           we share your personal information.
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>How do we keep your information safe? </strong>
                        <span className="at-text-light">
                           We have organizational and technical processes and procedures in place to
                           protect your personal information. However, no electronic transmission
                           over the internet or information storage technology can be guaranteed to
                           be 100% secure, so we cannot promise or guarantee that hackers,
                           cybercriminals, or other unauthorized third parties will not be able to
                           defeat our security and improperly collect, access, steal, or modify your
                           information. Learn more about how we keep your information safe.
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>What are your rights? </strong>
                        <span className="at-text-light">
                           Depending on where you are located geographically, the applicable privacy
                           law may mean you have certain rights regarding your personal information.
                        </span>
                     </div>

                     <div className="mb-2">
                        <strong>How do you exercise your rights? </strong>
                        <span className="at-text-light">
                           The easiest way to exercise your rights is by contacting us. We will
                           review and act upon any request in accordance with applicable data
                           protection laws.
                        </span>
                     </div>

                     <h4 className="mb-2 mt-5">TABLE OF CONTENTS </h4>

                     <ul className="content-list">
                        <li>1. WHAT INFORMATION DO WE COLLECT?</li>
                        <li>2. HOW DO WE PROCESS YOUR INFORMATION?</li>
                        <li>3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</li>
                        <li>4. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?</li>
                        <li>5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
                        <li>6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</li>
                        <li>7. HOW LONG DO WE KEEP YOUR INFORMATION?</li>
                        <li>8. HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
                        <li>9. WHAT ARE YOUR PRIVACY RIGHTS?</li>
                        <li>10. CONTROLS FOR DO-NOT-TRACK FEATURES</li>
                        <li>11. DO WE MAKE UPDATES TO THIS NOTICE?</li>
                        <li>12. HOW CAN YOU CONTACT US?</li>
                        <li>
                           13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
                        </li>
                     </ul>

                     <div className="mt-4 terms-details">
                        <h4>1. WHAT INFORMATION DO WE COLLECT?</h4>

                        <h5>Personal information you disclose to us</h5>
                        <p className="mb-2">
                           <strong>Summary:</strong> We collect personal information that you
                           provide to us.
                        </p>
                        <p className="mb-2">
                           We collect personal information that you voluntarily provide to us when
                           you register for the Services, express an interest in obtaining
                           information about us or our products and Services, when you participate
                           in activities for the Services, or otherwise when you contact us.
                        </p>

                        <h5>Personal Information Provided by You</h5>
                        <p className="mb-2">
                           The personal information that we collect depends on the context of your
                           interactions with us and the Services, the choices you make, and the
                           products and features you use. The personal information we collect may
                           include the following:
                        </p>
                        <ul className="list">
                           <li>Debit/credit card numbers</li>
                           <li>Billing addresses</li>
                           <li>Contact or authentication data</li>
                           <li>Contact preferences</li>
                           <li>Passwords</li>
                           <li>Usernames</li>
                           <li>Job titles</li>
                           <li>Mailing addresses</li>
                           <li>Email addresses</li>
                           <li>Phone numbers</li>
                           <li>Names</li>
                        </ul>

                        <h5>Sensitive Information</h5>
                        <p className="mb-2">
                           When necessary, with your consent or as otherwise permitted by applicable
                           law, we process the following categories of sensitive information:
                        </p>
                        <ul className="list">
                           <li>Financial data</li>
                           <li>Health data</li>
                           <li>Genetic data</li>
                           <li>Biometric data</li>
                           <li>Data about a person's sex life or sexual orientation</li>
                           <li>Information revealing race or ethnic origin</li>
                           <li>Information revealing political opinions</li>
                           <li>Information revealing religious or philosophical beliefs</li>
                           <li>Information revealing trade union membership</li>
                           <li>Credit worthiness data</li>
                           <li>Student data</li>
                           <li>Social security numbers or other government identifiers</li>
                        </ul>

                        <h5>Payment Data</h5>
                        <p className="mb-2">
                           We may collect data necessary to process your payment if you make
                           purchases, such as your payment instrument number, and the security code
                           associated with your payment instrument. All payment data is stored by
                           [PAYMENT PROCESSOR]. You may find their privacy notice link(s) here:
                           [PAYMENT PROCESSOR PRIVACY URL].
                        </p>

                        <h5>Social Media Login Data</h5>
                        <p className="mb-2">
                           We may provide you with the option to register with us using your
                           existing external account details, like your Google, Microsoft, Facebook,
                           X, or any other social media accounts.
                        </p>

                        <h5>Application Data</h5>
                        <p className="mb-2">
                           If you use our application(s), we also may collect the following
                           information if you choose to provide us with access or permission:
                        </p>
                        <ul className="list">
                           <li>
                              Geolocation Information: We may request access or permission to track
                              location-based information from your mobile device, either
                              continuously or while you are using our mobile application(s), to
                              provide certain location-based services. If you wish to change our
                              access or permissions, you may do so in your device's settings.
                           </li>
                           <li>
                              Mobile Device Access: We may request access or permission to certain
                              features from your mobile device, including your mobile device's
                              bluetooth, calendar, camera, contacts, microphone, reminders, sensors,
                              sms messages, social media accounts, storage, and other features. If
                              you wish to change our access or permissions, you may do so in your
                              device's settings.
                           </li>
                           <li>
                              Mobile Device Data: We automatically collect device information (such
                              as your mobile device ID, model, and manufacturer), operating system,
                              version information and system configuration information, device and
                              application identification numbers, browser type and version, hardware
                              model Internet service provider and/or mobile carrier, and Internet
                              Protocol (IP) address (or proxy server). If you are using our
                              application(s), we may also collect information about the phone
                              network associated with your mobile device, your mobile device’s
                              operating system or platform, the type of mobile device you use, your
                              mobile device’s unique device ID, and information about the features
                              of our application(s) you accessed.
                           </li>
                           <li>
                              Push Notifications: We may request to send you push notifications
                              regarding your account or certain features of the application(s). If
                              you wish to opt out from receiving these types of communications, you
                              may turn them off in your device's settings.
                           </li>
                        </ul>
                        <p className="mb-2">
                           This information is primarily needed to maintain the security and
                           operation of our application(s), for troubleshooting, and for our
                           internal analytics and reporting purposes.
                        </p>
                        <p className="mb-2">
                           All personal information that you provide to us must be true, complete,
                           and accurate, and you must notify us of any changes to such personal
                           information.
                        </p>

                        <h5>Information automatically collected</h5>
                        <p className="mb-2">
                           <strong>Summary:</strong> Some information — such as your Internet
                           Protocol (IP) address and/or browser and device characteristics — is
                           collected automatically when you visit our Services.
                        </p>
                        <p className="mb-2">
                           We automatically collect certain information when you visit, use, or
                           navigate the Services. This information does not reveal your specific
                           identity (like your name or contact information) but may include device
                           and usage information, such as your IP address, browser and device
                           characteristics, operating system, language preferences, referring URLs,
                           device name, country, location, information about how and when you use
                           our Services, and other technical information. This information is
                           primarily needed to maintain the security and operation of our Services
                           and for our internal analytics and reporting purposes.
                        </p>

                        <h5>Log and Usage Data</h5>
                        <p className="mb-2">
                           Log and usage data is service-related, diagnostic, usage, and performance
                           information our servers automatically collect when you access or use our
                           Services and which we record in log files. Depending on how you interact
                           with us, this log data may include your IP address, device information,
                           browser type, settings and information about your activity in the
                           Services including, but not limited to, the date/time stamps associated
                           with your usage, pages and files viewed, searches, actions you take such
                           as which features you use, device event information such as system
                           activity, error reports (sometimes called "crash dumps"), and hardware
                           settings.
                        </p>

                        <h5>Device Data</h5>
                        <p className="mb-2">
                           We collect device data such as information about your computer, phone,
                           tablet, or other device you use to access the Services. Depending on the
                           device used, this device data may include information such as your IP
                           address (or proxy server), device and application identification numbers,
                           location, browser type, hardware model, Internet service provider and/or
                           mobile carrier, operating system, and system configuration information.
                        </p>

                        <h5>Location Data</h5>
                        <p className="mb-2">
                           We collect location data such as information about your device's
                           location, which can be either precise or imprecise. How much information
                           we collect depends on the type and settings of the device you use to
                           access the Services. For example, we may use GPS and other technologies
                           to collect geolocation data that tells us your current location (based on
                           your IP address), but only when necessary to provide certain
                           location-based Services. You can opt out of allowing us to collect this
                           information either by refusing access to the information or by disabling
                           your Location setting on your device. However, if you choose to opt out,
                           you may not be able to use certain aspects of the Services.
                        </p>

                        <h5>Aggregate Information</h5>
                        <p className="mb-2">
                           We collect statistical information about how both unregistered and
                           registered users, collectively, use the Services. Some of this
                           information is derived from personal information. This statistical data
                           is not personal information and cannot be tied back to you, your account,
                           or your web browser.
                        </p>

                        <h5>Information collected from other sources</h5>
                        <p className="mb-2">
                           <strong>Summary:</strong> We may collect limited data from public
                           databases, marketing partners, social media platforms, and other outside
                           sources.
                        </p>
                        <p className="mb-2">
                           For the purpose of enhancing our ability to provide relevant marketing,
                           offers, and Services to you and update our records, we may obtain
                           information about you from other sources, such as public databases, joint
                           marketing partners, affiliate programs, data providers, social media
                           platforms, and from other third parties. This information includes
                           mailing addresses, job titles, email addresses, phone numbers, intent
                           data (or user behavior data), Internet Protocol (IP) addresses, social
                           media profiles, social media URLs, and custom profiles, for purposes of
                           targeted advertising and event promotion. If you interact with us on a
                           social media platform using your social media account (e.g., Facebook or
                           Twitter), we receive personal information about you such as your name,
                           email address, and gender. Any personal information that we collect from
                           your social media account is subject to your social media account's
                           privacy settings, and we encourage you to review these settings and
                           adjust them to your comfort level.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>2. HOW DO WE PROCESS YOUR INFORMATION?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> We process your information to provide,
                           improve, and administer our Services, communicate with you, for security
                           and fraud prevention, and to comply with law. We may also process your
                           information for other purposes with your consent.
                        </p>

                        <p className="mb-2">
                           We process your personal information for a variety of reasons, depending
                           on how you interact with our Services, including:
                        </p>

                        <ul className="list">
                           <li>
                              <strong>
                                 To facilitate account creation and authentication and otherwise
                                 manage user accounts:
                              </strong>{' '}
                              We may process your information so you can create and log in to your
                              account, as well as keep your account in working order.
                           </li>
                           <li>
                              <strong>
                                 To deliver and facilitate the delivery of Services to the user:
                              </strong>{' '}
                              We may process your information to provide you with the requested
                              service.
                           </li>
                           <li>
                              <strong>To respond to user inquiries/offer support to users:</strong>{' '}
                              We may process your information to respond to your inquiries and solve
                              any potential issues you might have with the requested service.
                           </li>
                           <li>
                              <strong>To send administrative information to you:</strong> We may
                              process your information to send you details about our products and
                              Services, changes to our terms and policies, and other similar
                              information.
                           </li>
                           <li>
                              <strong>To fulfill and manage your orders:</strong> We may process
                              your information to fulfill and manage your orders, payments, returns,
                              and exchanges made through the Services.
                           </li>
                           <li>
                              <strong>To enable user-to-user communications:</strong> We may process
                              your information if you choose to use any of our offerings that allow
                              for communication with another user.
                           </li>
                           <li>
                              <strong>To request feedback:</strong> We may process your information
                              when necessary to request feedback and to contact you about your use
                              of our Services.
                           </li>
                           <li>
                              <strong>To send you marketing and promotional communications:</strong>{' '}
                              We may process the personal information you send to us for our
                              marketing purposes in accordance with your marketing preferences. You
                              can opt out of our marketing emails at any time.
                           </li>
                           <li>
                              <strong>To deliver targeted advertising to you:</strong> We may
                              process your information to develop and display personalized content
                              and advertising tailored to your interests, location, and more.
                           </li>
                           <li>
                              <strong>To protect our Services:</strong> We may process your
                              information as part of our efforts to keep our Services safe and
                              secure, including fraud monitoring and prevention.
                           </li>
                           <li>
                              <strong>To identify usage trends:</strong> We may process information
                              about how you use our Services to better understand how they are being
                              used so we can improve them.
                           </li>
                           <li>
                              <strong>
                                 To determine the effectiveness of our marketing and promotional
                                 campaigns:
                              </strong>{' '}
                              We may process your information to better understand how to provide
                              marketing and promotional campaigns that are most relevant to you.
                           </li>
                           <li>
                              <strong>To save or protect an individual's vital interest:</strong> We
                              may process your information when necessary to save or protect an
                              individual’s vital interest, such as to prevent harm.
                           </li>
                        </ul>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> We may share information in specific situations
                           described in this section and/or with the following categories of third
                           parties.
                        </p>

                        <h5>Vendors, Consultants, and Other Third-Party Service Providers</h5>
                        <p className="mb-2">
                           We may share your data with third-party vendors, service providers,
                           contractors, or agents ("third parties") who perform services for us or
                           on our behalf and require access to such information to do that work. We
                           have contracts in place with our third parties, which are designed to
                           help safeguard your personal information. This means that they cannot do
                           anything with your personal information unless we have instructed them to
                           do it. They will also not share your personal information with any
                           organization apart from us. They also commit to protect the data they
                           hold on our behalf and to retain it for the period we instruct. The
                           categories of third parties we may share personal information with are as
                           follows:
                        </p>
                        <ul className="list">
                           <li>Ad Networks</li>
                           <li>Cloud Computing Services</li>
                           <li>Communication & Collaboration Tools</li>
                           <li>Data Analytics Services</li>
                           <li>Data Storage Service Providers</li>
                           <li>Finance & Accounting Tools</li>
                           <li>Payment Processors</li>
                           <li>Sales & Marketing Tools</li>
                           <li>User Account Registration & Authentication Services</li>
                           <li>Affiliate Marketing Programs</li>
                           <li>Government Entities</li>
                           <li>Order Fulfillment Service Providers</li>
                           <li>Performance Monitoring Tools</li>
                           <li>Product Engineering & Design Tools</li>
                           <li>Retargeting Platforms</li>
                           <li>Social Networks</li>
                           <li>Testing Tools</li>
                           <li>Website Hosting Service Providers</li>
                        </ul>

                        <h5>When we use Google Maps Platform APIs</h5>
                        <p className="mb-2">
                           We may share your information with certain Google Maps Platform APIs
                           (e.g., Google Maps API, Places API). We obtain and store on your device
                           ("cache") your location. You may revoke your consent anytime by
                           contacting us at the contact details provided at the end of this
                           document.
                        </p>

                        <h5>Affiliates</h5>
                        <p className="mb-2">
                           We may share your information with our affiliates, in which case we will
                           require those affiliates to honor this privacy notice. Affiliates include
                           our parent company and any subsidiaries, joint venture partners, or other
                           companies that we control or that are under common control with us.
                        </p>

                        <h5>Business Partners</h5>
                        <p className="mb-2">
                           We may share your information with our business partners to offer you
                           certain products, services, or promotions.
                        </p>

                        <h5>Other Users</h5>
                        <p className="mb-2">
                           When you share personal information (for example, by posting comments,
                           contributions, or other content to the Services) or otherwise interact
                           with public areas of the Services, such personal information may be
                           viewed by all users and may be publicly made available outside the
                           Services in perpetuity. If you interact with other users of our Services
                           and register for our Services through a social network (such as
                           Facebook), your contacts on the social network will see your name,
                           profile photo, and descriptions of your activity. Similarly, other users
                           will be able to view descriptions of your activity, communicate with you
                           within our Services, and view your profile.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>4. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> We are not responsible for the safety of any
                           information that you share with third parties that we may link to or who
                           advertise on our Services, but are not affiliated with our Services.
                        </p>

                        <p className="mb-2">
                           The Services may link to third-party websites, online services, or mobile
                           applications and/or contain advertisements from third parties that are
                           not affiliated with us and which may link to other websites, services, or
                           applications. Accordingly, we do not make any guarantee regarding any
                           such third parties, and we will not be liable for any loss or damage
                           caused by the use of such third-party websites, services, or
                           applications.
                        </p>

                        <p className="mb-2">
                           The inclusion of a link to a third-party website, service, or application
                           does not imply an endorsement by us. We cannot guarantee the safety and
                           privacy of data you provide to any third parties. Any data collected by
                           third parties is not covered by this privacy notice. We are not
                           responsible for the content or privacy and security practices and
                           policies of any third parties, including other websites, services, or
                           applications that may be linked to or from the Services.
                        </p>

                        <p className="mb-2">
                           You should review the policies of such third parties and contact them
                           directly to respond to your questions.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> We may use cookies and other tracking
                           technologies to collect and store your information.
                        </p>

                        <p className="mb-2">
                           We may use cookies and similar tracking technologies (like web beacons
                           and pixels) to access or store information. Specific information about
                           how we use such technologies and how you can refuse certain cookies is
                           set out in our <a href="/cookie-notice">Cookie Notice</a>.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>6. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> If you choose to register or log in to our
                           Services using an external account, we may have access to certain
                           information about you.
                        </p>

                        <p className="mb-2">
                           Our Services offer you the ability to register and log in using your
                           third-party email or social media account details (like your Google,
                           Microsoft, Facebook, or X logins). Where you choose to do this, we will
                           receive certain profile information about you from your social media
                           provider.
                        </p>

                        <p className="mb-2">
                           The profile information we receive may vary depending on the social media
                           provider concerned, but will often include your name, email address,
                           friends list, and profile picture, as well as other information you
                           choose to make public on such a social media platform.
                        </p>

                        <p className="mb-2">
                           We will use the information we receive only for the purposes that are
                           described in this privacy notice or that are otherwise made clear to you
                           on the relevant Services. Please note that we do not control, and are not
                           responsible for, other uses of your personal information by your
                           third-party social media provider.
                        </p>

                        <p className="mb-2">
                           We recommend that you review their privacy notice to understand how they
                           collect, use, and share your personal information, and how you can set
                           your privacy preferences on their sites and apps.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>7. HOW LONG DO WE KEEP YOUR INFORMATION?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> We keep your information for as long as
                           necessary to fulfill the purposes outlined in this privacy notice unless
                           otherwise required by law.
                        </p>

                        <p className="mb-2">
                           We will only keep your personal information for as long as it is
                           necessary for the purposes set out in this privacy notice unless a longer
                           retention period is required or permitted by law (such as tax,
                           accounting, or other legal requirements). No purpose in this notice will
                           require us to keep your personal information for longer than twelve (12)
                           months past the termination of the user's account.
                        </p>

                        <p className="mb-2">
                           When we have no ongoing legitimate business need to process your personal
                           information, we will either delete or anonymize such information, or, if
                           this is not possible (for example, because your personal information has
                           been stored in backup archives), then we will securely store your
                           personal information and isolate it from any further processing until
                           deletion is possible.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>8. HOW DO WE KEEP YOUR INFORMATION SAFE?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> We aim to protect your personal information
                           through a system of organizational and technical security measures.
                        </p>

                        <p className="mb-2">
                           We have implemented appropriate and reasonable technical and
                           organizational security measures designed to protect the security of any
                           personal information we process. However, despite our safeguards and
                           efforts to secure your information, no electronic transmission over the
                           Internet or information storage technology can be guaranteed to be 100%
                           secure. Therefore, we cannot promise or guarantee that hackers,
                           cybercriminals, or other unauthorized third parties will not be able to
                           defeat our security and improperly collect, access, steal, or modify your
                           information.
                        </p>

                        <p className="mb-2">
                           Although we will do our best to protect your personal information,
                           transmission of personal information to and from our Services is at your
                           own risk. You should only access the Services within a secure
                           environment.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>9. WHAT ARE YOUR PRIVACY RIGHTS?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> You may review, change, or terminate your
                           account at any time.
                        </p>

                        <h5>Opting Out of Marketing and Promotional Communications</h5>
                        <p className="mb-2">
                           You can unsubscribe from our marketing and promotional communications at
                           any time by clicking on the unsubscribe link in the emails that we send,
                           replying "STOP" or "UNSUBSCRIBE" to the SMS messages that we send, or by
                           contacting us using the details provided in the section{' '}
                           <strong>"HOW CAN YOU CONTACT US?"</strong> below.
                        </p>
                        <p className="mb-2">
                           You will then be removed from the marketing lists. However, we may still
                           communicate with you — for example, to send you service-related messages
                           necessary for the administration and use of your account, to respond to
                           service requests, or for other non-marketing purposes.
                        </p>

                        <h5>Account Information</h5>
                        <p className="mb-2">
                           If you would at any time like to review or change the information in your
                           account or terminate your account, you can:
                        </p>
                        <ul className="list">
                           <li>Log in to your account settings and update your user account.</li>
                        </ul>
                        <p className="mb-2">
                           Upon your request to terminate your account, we will deactivate or delete
                           your account and information from our active databases. However, we may
                           retain some information in our files to prevent fraud, troubleshoot
                           problems, assist with any investigations, enforce our legal terms, and/or
                           comply with applicable legal requirements.
                        </p>

                        <h5>Cookies and Similar Technologies</h5>
                        <p className="mb-2">
                           Most web browsers are set to accept cookies by default. If you prefer,
                           you can usually choose to set your browser to remove cookies and to
                           reject cookies. If you choose to remove cookies or reject cookies, this
                           could affect certain features or services of our Services.
                        </p>
                        <p className="mb-2">
                           You may also opt out of interest-based advertising by advertisers on our
                           Services.
                        </p>

                        <h5>Contact Us About Your Privacy Rights</h5>
                        <p className="mb-2">
                           If you have questions or comments about your privacy rights, you may
                           email us at <a href="mailto:support@atenya.ai">support@atenya.ai</a>.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>10. CONTROLS FOR DO-NOT-TRACK FEATURES</h4>

                        <p className="mb-2">
                           Most web browsers and some mobile operating systems and mobile
                           applications include a Do-Not-Track ("DNT") feature or setting you can
                           activate to signal your privacy preference not to have data about your
                           online browsing activities monitored and collected.
                        </p>

                        <p className="mb-2">
                           At this stage, no uniform technology standard for recognizing and
                           implementing DNT signals has been finalized. As such, we do not currently
                           respond to DNT browser signals or any other mechanism that automatically
                           communicates your choice not to be tracked online.
                        </p>

                        <p className="mb-2">
                           If a standard for online tracking is adopted that we must follow in the
                           future, we will inform you about that practice in a revised version of
                           this privacy notice.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>11. DO WE MAKE UPDATES TO THIS NOTICE?</h4>

                        <p className="mb-2">
                           <strong>Summary:</strong> Yes, we will update this notice as necessary to
                           stay compliant with relevant laws.
                        </p>

                        <p className="mb-2">
                           We may update this privacy notice from time to time. The updated version
                           will be indicated by an updated "Revised" date, and the updated version
                           will be effective as soon as it is accessible. If we make material
                           changes to this privacy notice, we may notify you either by prominently
                           posting a notice of such changes or by directly sending you a
                           notification. We encourage you to review this privacy notice frequently
                           to be informed of how we are protecting your information.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>12. HOW CAN YOU CONTACT US?</h4>

                        <p className="mb-2">
                           If you have questions or comments about this notice, you may contact our
                           Data Protection Officer (DPO), Ritesh Agarwal, by email at{' '}
                           <a href="mailto:support@atenya.ai">support@atenya.ai</a>, or contact us
                           by post at:
                        </p>

                        <p className="mb-2">
                           Atenya Intelligence Inc.
                           <br />
                           Ritesh Agarwal
                           <br />
                           867 Boylston Street
                           <br />
                           5th Floor #2166
                           <br />
                           Boston, MA 02116
                        </p>

                        <p className="mb-2">
                           If you are a resident of the European Economic Area or Switzerland, we
                           are the "data controller" of your personal information. We have appointed{' '}
                           <strong>[EU REP]</strong> to be our representative in the EEA and
                           Switzerland. You can contact them directly regarding our processing of
                           your information by email at{' '}
                           <a href="mailto:[EU REP EMAIL]">[EU REP EMAIL]</a> or by visiting{' '}
                           <a href="[EU REP URL]">[EU REP URL]</a>.
                        </p>

                        <p className="mb-2">
                           If you are a resident in the United Kingdom, we are the "data controller"
                           of your personal information. We have appointed <strong>[UK REP]</strong>{' '}
                           to be our representative in the UK. You can contact them directly
                           regarding our processing of your information by email at{' '}
                           <a href="mailto:[UK REP EMAIL]">[UK REP EMAIL]</a> or by visiting{' '}
                           <a href="[UK REP URL]">[UK REP URL]</a>.
                        </p>
                     </div>

                     <div className="mt-4 terms-details">
                        <h4>
                           13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
                        </h4>

                        <p className="mb-2">
                           Based on the applicable laws of your country, you may have the right to
                           request access to, modification of, or deletion of the personal
                           information we collect from you. To exercise these rights, please send an
                           email to <a href="mailto:support@atenya.ai">support@atenya.ai</a>.
                        </p>
                     </div>
                  </div>
               </div>
            </Container>
         </div>
      </div>
   )
}
